module.exports = __webpack_public_path__ + "img/happy-new-beer-plisner.af7e5225.png";